// const serverUrl = 'http://192.168.0.101:8094/jointat-mfb-admin'
// const serverUrl = 'http://192.168.0.220:8085/jointat-mfb-admin'
const serverUrl = 'http://www.pengzushijia.com/jointat-mfb-admin'
// const serverUrl = 'http://admin.myfamilybook.cn/jointat-mfb-admin'
export default {
  serverUrl
}
